/* eslint-disable react/jsx-props-no-spreading */
import { TextField, Autocomplete, SxProps, Theme } from "@mui/material";
import { EntityFieldItem } from "../../services/cleaning-data-service";

interface FieldAutocompleteProps {
  options: EntityFieldItem[];
  value: EntityFieldItem | null;
  onFieldChange: (field: EntityFieldItem | null) => void;
  disabled?: boolean;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

const FieldAutocomplete = ({
  options,
  value,
  onFieldChange,
  disabled = false,
  placeholder = "Target Field",
  sx,
}: FieldAutocompleteProps) => {
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: EntityFieldItem | null,
  ) => {
    onFieldChange(newValue);
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => {
        let label = option.name;
        if (option.templateInformation?.description) {
          label += ` (${option.templateInformation.description})`;
        }
        return label;
      }}
      value={value}
      onChange={handleChange}
      size="small"
      disabled={disabled}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          paddingRight: "8px",
          "& fieldset": {
            borderColor: "grey.400",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        },
        ...sx,
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} />
      )}
    />
  );
};

export default FieldAutocomplete;
